/**
 * Feature flag keys — must match the backend Feature enum values.
 * @see Modules/Backoffice/Enums/Feature.php
 */
export const FEATURES = {
  TIME_OFF: 'time_off',
  LEARNING: 'learning',
  ORG_CHART: 'org_chart',
} as const;

export type FeatureKey = (typeof FEATURES)[keyof typeof FEATURES];
